import { usersApi } from "./lib/users"
import { permissionsApi } from "./lib/permissions"
import { utilityApi } from "./lib/utility"
import { getConfig } from "../../config"

/**
 * @typedef {{
 *  user: ReturnType<typeof usersApi>,
 *  permissions: ReturnType<typeof permissionsApi>
 *  utility: ReturnType<typeof utilityApi>
 * }} EntitlexApi
 */

/**
 * @type {import("../../hooks/useApi").ApiFactory<EntitlexApi}
 */
export const entitlex = (token, origin = getConfig().entitlexApiOrigin) => ({
  user: usersApi(origin, token),
  permissions: permissionsApi(origin, token),
  utility: utilityApi(origin, token)
})
